import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useTranslation } from 'react-i18next'

import { SelectDropdown as SelectDropdownType } from 'types/SelectDropdown'
import 'components/Shared/SelectDropdown/selectDropdown.scss'

type FilterDropdownProps = {
  value: string
  selectDropdownOptions: SelectDropdownType
  onChangeFilterDropdown: (interval: string) => void
}

const SelectDropdown = (props: FilterDropdownProps) => {
  const { t } = useTranslation()

  const { value, selectDropdownOptions, onChangeFilterDropdown } = props

  const handleChange = (event: SelectChangeEvent) => {
    onChangeFilterDropdown(event.target.value)
  }

  return (
    <FormControl
      variant="standard"
      sx={{ marginTop: '0.313rem', minWidth: 120 }}
    >
      <Select
        value={value}
        onChange={handleChange}
        MenuProps={{ classes: { root: 'select-dropdown' } }}
        autoWidth
        data-html2canvas-ignore="true"
        className="select-dropdown-main"
        data-testid="select-dropdown-testid"
      >
        {selectDropdownOptions.map(({ key, value, disabled }) => {
          return (
            <MenuItem key={key} value={value} disabled={disabled}>
              {t(`common.${key}`)}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default SelectDropdown
